var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "month-status-box" },
    _vm._l(12, function(i) {
      return _c("div", { staticClass: "month-status" }, [
        _c("div", { staticClass: "name" }, [
          _vm._v("\n      " + _vm._s(i) + "月\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "value",
            class: _vm.standardData[i]
              ? _vm.$util.getRiskLevelBgColor(_vm.standardData[i].level)
              : "default-bg-color"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.standardData[i] ? _vm.standardData[i].value : null) +
                "\n    "
            )
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20a7f4a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a7f4a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/risk/CoreRiskMonth.vue
// module id = null
// module chunks = 